import React from 'react';
import { CircularProgress } from '@material-ui/core';
import { usePublicEndpointByIdApi } from '@/hooks/api/usePublicEndpointApi';
import MobileInferenceCardDisabled from './MobileInferenceCardDisabled';
import MobileInferenceCardEnabled from './MobileInferenceCardEnabled';

type MobileInferenceCardProps = {
  projectId: number;
  endpointId?: string;
  inferenceCost: number;
  onQrCodeGenerated?: () => void;
};

const MobileInferenceCard: React.FC<MobileInferenceCardProps> = props => {
  const { projectId, endpointId, inferenceCost, onQrCodeGenerated } = props;
  const [endpointData, loading] = usePublicEndpointByIdApi(endpointId);

  if (loading || !endpointData) {
    return <CircularProgress color="primary" size={24} />;
  }
  return endpointData.enable ? (
    <MobileInferenceCardEnabled
      projectId={projectId}
      endpointId={endpointId}
      inferenceCost={inferenceCost}
    />
  ) : (
    <MobileInferenceCardDisabled
      projectId={projectId}
      endpointId={endpointId}
      onQrCodeGenerated={onQrCodeGenerated}
    />
  );
};

export default MobileInferenceCard;
